export default "__VITE_ASSET__03i9WotA__"